import { P, SharedColors } from "apparatus/library/common";
import { Path } from "paper";
const DEFAULT_SWATCHES = {
    'Red': SharedColors.ray,
    'Yellow': '#f1f18a',
    'Green': '#3ac433',
    'Blue': '#1aa9db',
    'Black': '#282828',
};
/** Minimum distance between two points before an arrow ca be drawn. */
const MIN_RAY_DISTANCE_FOR_ARROW = 50;
const ARROW_SIZE = 8;
export var Ray;
(function (Ray) {
    Ray.header = {
        spec: "header", header: "Ray", icon: "k,laser", toggleKey: "showRay",
    };
    Ray.defaultAppearanceRayOn = {
        showRay: true,
        rayColor: SharedColors.ray,
        rayThickness: 2.0,
    };
    Ray.defaultAppearanceRayOff = Object.assign(Object.assign({}, Ray.defaultAppearanceRayOn), { showRay: false });
    Ray.defaultAppearanceArrow = {
        showRayArrow: false,
    };
    Ray.specsRayOnly = [
        {
            spec: "slider", key: "rayThickness", label: "Strength",
            min: 1.0, max: 5.0, step: 0.5
        },
        {
            spec: "color", key: "rayColor", label: "Colour", swatches: DEFAULT_SWATCHES
        },
    ];
    Ray.specs = [
        Ray.header,
        ...Ray.specsRayOnly.map(s => (Object.assign(Object.assign({}, s), { visible: (a) => a.showRay && (!s.visible || s.visible(a)) }))),
    ];
    Ray.arrowSpecs = [
        { spec: "checkbox", key: "showRayArrow", label: "Show arrows", visible: a => a.showRay },
    ];
    function applyStyle(ray, appearance) {
        ray.withStroke(appearance.rayThickness, appearance.rayColor);
    }
    Ray.applyStyle = applyStyle;
    function maybeAddArrows(a, path, positions, group) {
        if (!a.showRayArrow)
            return;
        for (let i = 0; i < path.segments.length - 1; i++) {
            const position = positions[Math.min(i, positions.length - 1)];
            if (position == null)
                continue;
            const start = path.segments[i].point;
            const end = path.segments[i + 1].point;
            if (start.getDistance(end) >= MIN_RAY_DISTANCE_FOR_ARROW) {
                group.addChild(drawFilledArrowHead(start, end, position, ARROW_SIZE, a.rayColor, a.rayThickness));
            }
        }
    }
    Ray.maybeAddArrows = maybeAddArrows;
    function drawFilledArrowHead(start, end, position, size, color, thickness) {
        const at = start.multiply(1 - position).add(end.multiply(position));
        const arrowSize = P(0, size + thickness * 2);
        const arrow = new Path([
            [0, 0], arrowSize.rotate(20), arrowSize.rotate(-20),
        ]).withFill(color);
        // Shift the arrow
        arrow.position = at;
        arrow.rotate(start.subtract(end).angle - 90);
        return arrow;
    }
})(Ray || (Ray = {}));
